import type { ReactNode } from 'react';

import ActionSheet, { Background, Sheet } from '@components/ActionSheet';
import { PreventWindowScroll } from './components/PreventWindowScroll';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  children?: ReactNode;
};

export const NarrativeFairValueActionSheet = ({
  isOpen,
  onClose,
  children,
}: Props) => {
  return (
    <ActionSheet open={isOpen} onClose={onClose}>
      <PreventWindowScroll />
      <Background onClick={onClose} />
      <Sheet>
        <div
          className="grid grid-rows-[40px_auto]"
          data-cy-id="narrative-fair-value-modal"
        >
          <div className="row-start-2 grid rounded-t-x2 bg-surface-1">
            {children}
          </div>
        </div>
      </Sheet>
    </ActionSheet>
  );
};
